import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator"; 
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { FormControl } from '@angular/forms';
import { CountService } from 'src/app/core/services/count.service';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent {

  showOverlay=false
  headerData: any;
  ogData:any;
  customers: any;
  total_product:any
  superuser:any;
  d2c_name:any;
  portal_id:any;
  portal_account_id:any;
  searchdata:any;  
  portal_name:any;
  isCancelled: boolean = false;
  isOptionSelected: boolean = false
  startIndex:any
  unread_tickets:any
  fullData: any;
  apiData: any = [];
  apiData1:any = [];
  pageIndex:number = 0;
pageSize:any;
pageSizeOptions: number[] = [10, 20, 50, 100]; 
page:any;     
length:any;
page_no:number=1;
config:any;
paginate: any = {
  length: 0,
  pageIndex: 0,
  pageSize: 10,
  previousPageIndex: 1
  }
  filteredData: any; 
  currentFilter: string | null = 'open'; 
pageEvent:any;
vendorForm = new FormControl('')
displayedColumns: string[] | undefined;
@ViewChild(MatSort, { static: false }) sort: MatSort | undefined;
@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator | undefined; 
  @ViewChild('select') select: MatSelect;
  resolvedDate_start_date = new FormControl('');
  resolvedDate_end_date = new FormControl('');
    resolvedDate_start_date1 = new FormControl('');
  resolvedDate_end_date1 = new FormControl('');
  search_order_id = new FormControl('');
    search_order_id1 = new FormControl('');
      updated_by = new FormControl('');
      @ViewChild('InvoicenumberTemplate') InvoicenumberTemplate!: TemplateRef<any>;
        @ViewChild('InvoicenumberTemplate1') InvoicenumberTemplate1!: TemplateRef<any>;
        @ViewChild('inputFieldBrand') inputFieldBrand: ElementRef;
            @ViewChild('inputFieldDivision') inputFieldDivision: ElementRef;

        




constructor(
  private authService:AuthenticationService,
  private modalServicee: NgbModal,
  private router: Router,
  private toastr: ToastrService,
  private countservice :CountService,
  private modalService: NgbModal,

  ){

}

ngOnInit(): void {
  this.fetchData(this.paginate,'open');
  this.assigned_to()
  this.superuser = localStorage.getItem('superuser')
  this.unread_tickets = JSON.parse(localStorage.getItem('ticketss') || '[]');
  console.log('unread_tickets',this.unread_tickets)
  this.countservice.unread_ticket()
  // console.log(this.length,'lengthhhhhhhh')

}

isUnreadTicket(ticketId: number): boolean {
  return this.unread_tickets.some(ticket => ticket.ticket_id === ticketId);
}


fetchData(event:PageEvent,status:any) {
  this.superuser = localStorage.getItem('is_superuser')

  if(this.superuser == 'true'){
          this.portal_name = localStorage.getItem('portal_name2')
          this.portal_id = localStorage.getItem('portal_id2')
          this.portal_account_id = localStorage.getItem('portal_account_id2')
          this.d2c_name = localStorage.getItem('d2c_name2')
    
        }
        else{
          this.portal_name = localStorage.getItem('portal_name')
           this.portal_id = localStorage.getItem('portal_id')
          this.portal_account_id = localStorage.getItem('portal_account_id')
          this.d2c_name = localStorage.getItem('d2c_name')
        }
     this.showOverlay=true 
 this.paginate = event;
 this.length = +event.length;
 this.pageIndex = +event.pageIndex;
 this.pageSize = +event.pageSize;
//  console.log(this.pageSize,'this.pagesize')
 this.startIndex = +event.pageIndex * event.pageSize
 let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1

let payload_data = {
  page_number: page_no,
  page_size: this.pageSize,
  portal_account_id: this.portal_account_id,
  ticket: 'order_ticket',
  status: status,
  category: this.vendorForm.value ?? '',
  updated_by:this.updated_by.value ?? '',
  raised_by:this.search_order_id1.value ?? '',
  order_id:this.search_order_id.value ?? '',
};

// START DATE
if (!this.resolvedDate_start_date.value) {
  payload_data["created_at_start"] = '';
} else {
  payload_data["created_at_start"] = this.changedateFormate(this.resolvedDate_start_date.value);
}

// END DATE
if (!this.resolvedDate_end_date.value) {
  payload_data["created_at_end"] = '';
} else {
  payload_data["created_at_end"] = this.changedateFormate(this.resolvedDate_end_date.value);
}

if (!this.resolvedDate_start_date1.value) {
  payload_data["updated_at_start"] = '';
} else {
  payload_data["updated_at_start"] = this.changedateFormate(this.resolvedDate_start_date1.value);
}

// END DATE
if (!this.resolvedDate_end_date1.value) {
  payload_data["updated_at_end"] = '';
} else {
  payload_data["updated_at_end"] = this.changedateFormate(this.resolvedDate_end_date1.value);
}

  this.authService.ticket_view1(payload_data).subscribe((res) => {
    let mes=JSON.parse(res)
    res =mes 
    console.log(mes)
    this.total_product = mes.total_product
    if (res.statusCode>=200 && res.statusCode<=205) {
      this.showOverlay = false;
      this.length=mes.total_data
        this.fullData = res.body;  
        this.ogData =res.body
      this.headerData = res.headers;
      this.getData(this.fullData);
                  this.modalService.dismissAll('Close click'); 
    //   console.log("mesg", res.message); 
    // console.log(this.length,'lengthhhhhhhh')

    } 
    else {
      if(res.error =='Token has expired' || res.error =='Invalid token' || res.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(res.error, "");
        this.showOverlay = false; 
      }
    }
  }, (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
  });
}

  changedateFormate(data: any) {
    let date = new Date(data);
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

getData(data:any) {
  this.apiData = data;
  // console.log("this.apiData",this.apiData); 
  // console.log(this.apiData);
  delete this.headerData.email_id;
  delete this.headerData.order_id;
  this.displayedColumns = Object.keys(this.headerData);
  this.customers = new MatTableDataSource(this.apiData);
  this.customers.sort = this.sort;





  
}

downloadImage(url: string) {
  this.showOverlay = true
  if (!url || url.trim() === '') {
    this.toastr.error('Image URL is missing', 'Error');
    this.showOverlay = false
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = url.split('/').pop() || 'downloaded-image.png';
  document.body.appendChild(link);
  link.click();
  this.showOverlay = false
  document.body.removeChild(link);
}




applyFilter1(filterValue: any) {
  // console.log(filterValue.value)
  this.customers.filter = filterValue.value.trim().toLowerCase();
  if (this.customers.paginator) {
    this.customers.paginator.firstPage();
  }
}
ticket_details(row:any){
  localStorage.setItem('ticket_id',row.ticket_id)
  let data ={
    'ticket_id':row.ticket_id
  }
  this.showOverlay=true
  this.authService.ticket_details(data).subscribe((res: any) => {
    // console.log(res,'ticket data');
    let mes = JSON.parse(res);
    res = mes
    console.log(mes);
    if (mes.statusCode === 200) {
      this.showOverlay=false
      this.router.navigate(['page/retailripple/ticketview'])

      // this.toastr.success(mes.message, "");

      

}
else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(mes.error, "");
    this.showOverlay = false; 

  }


}
},
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});

}



  filterData() {
    if (this.apiData) {
      if (this.currentFilter === null) {
        this.customers.data = this.apiData;
      } else {
        this.customers.data = this.apiData.filter(record => record.status === this.currentFilter);
      }
    } else {
      this.customers.data = [];
    }
  }

setFilter(status: string | null) {
  this.currentFilter = status;
  this.fetchData(this.paginate, this.currentFilter);

}

onPageChange(event: PageEvent) {
  this.fetchData(event, this.currentFilter);
}

ticket_update(row){
  console.log(row)
  let data ={
    'ticket_id':row
  }
  this.showOverlay=true
  this.authService.unread(data).subscribe((res: any) => {
    // console.log(res,'ticket data');
    let mes = JSON.parse(res);
    res = mes
    console.log(mes);
    if (mes.statusCode === 200) {
      this.showOverlay=false
      this.countservice.unread_ticket();
      // location.reload();

      // this.router.navigate(['page/retailripple/ticketview'])

      // this.toastr.success(mes.message, "");

      

}
else{
  if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
    // this.authService.logout()
    this.showOverlay=false
    this.router.navigate(['/auth/login'])
  }
  else{
    this.toastr.error(mes.error, "");
    this.showOverlay = false; 

  }


}
},
(error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});



}

handleTicketClick(row: any): void {
  localStorage.setItem('email_id_id',row.email_id)
  console.log(row,'row123')
  if (this.isUnreadTicket(row['ticket_id'])) {
    this.ticket_update(row['ticket_id']);
    this.ticket_details(row);
  } else {
    this.ticket_details(row);
  }
}

  openDropdown() {
    if (this.select) {
      this.select.open();
    }
  }




  filteredPortal = [
    {status:'missing order',name:'Missing Order'},
    {status:'"wrong product dispatched',name:'Wrong Product Dispatched'},
    {status:'order not received',name:'Order Not Received'},
    {status:'missing quantity"',name:'Missing Quantity'},
    {status:'wrong invoice shared',name:'Wrong Invoice Shared'},
    {status:'order delay',name:'Order Delay'},
    {status:'other',name:'Other'},
    {status:'Product/Checkout Issues',name:'Product/Checkout Issues	'},

  ]

  closedFilter(){
    this.fetchData(this.paginate,this.currentFilter)

  }

  download(){
    this.fetchData1(this.paginate,this.currentFilter)

  }


  fetchData1(event:PageEvent,status:any) {
  this.superuser = localStorage.getItem('is_superuser')

  if(this.superuser == 'true'){
          this.portal_name = localStorage.getItem('portal_name2')
          this.portal_id = localStorage.getItem('portal_id2')
          this.portal_account_id = localStorage.getItem('portal_account_id2')
          this.d2c_name = localStorage.getItem('d2c_name2')
    
        }
        else{
          this.portal_name = localStorage.getItem('portal_name')
           this.portal_id = localStorage.getItem('portal_id')
          this.portal_account_id = localStorage.getItem('portal_account_id')
          this.d2c_name = localStorage.getItem('d2c_name')
        }
     this.showOverlay=true 
 this.paginate = event;
 this.length = +event.length;
 this.pageIndex = +event.pageIndex;
 this.pageSize = +event.pageSize;
//  console.log(this.pageSize,'this.pagesize')
 this.startIndex = +event.pageIndex * event.pageSize
 let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1

let payload_data = {
  page_number: page_no,
  page_size:100,
  portal_account_id: this.portal_account_id,
  ticket: 'order_ticket',
  status: status,
  category: this.vendorForm.value ?? '',
  download:true
};

// START DATE
if (!this.resolvedDate_start_date.value) {
  payload_data["created_at_start"] = '';
} else {
  payload_data["created_at_start"] = this.changedateFormate(this.resolvedDate_start_date.value);
}

// END DATE
if (!this.resolvedDate_end_date.value) {
  payload_data["created_at_end"] = '';
} else {
  payload_data["created_at_end"] = this.changedateFormate(this.resolvedDate_end_date.value);
}

if (!this.resolvedDate_start_date1.value) {
  payload_data["updated_at_start"] = '';
} else {
  payload_data["updated_at_start"] = this.changedateFormate(this.resolvedDate_start_date1.value);
}

// END DATE
if (!this.resolvedDate_end_date1.value) {
  payload_data["updated_at_end"] = '';
} else {
  payload_data["updated_at_end"] = this.changedateFormate(this.resolvedDate_end_date1.value);
}

  this.authService.ticket_view2(payload_data).subscribe((res) => {
    let mes=JSON.parse(res)
    res =mes 
    console.log(mes)
    this.total_product = mes.total_product
    if (res.statusCode>=200 && res.statusCode<=205) {
      this.showOverlay = false;
window.open(res.file_link, '_blank');


    } 
    else {
      if(res.error =='Token has expired' || res.error =='Invalid token' || res.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(res.error, "");
        this.showOverlay = false; 
      }
    }
  }, (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
  });
}

download1(){
  this.resolvedDate_start_date1.setValue('')
  this.resolvedDate_end_date1.setValue('')
  this.resolvedDate_end_date.setValue('')
  this.resolvedDate_start_date.setValue('')
  this.vendorForm.setValue('')
  this.search_order_id.setValue('')
  this.search_order_id1.setValue('')
  this.updated_by.setValue('')
  this.fetchData(this.paginate,this.currentFilter)


}

download2(){
  this.fetchData(this.paginate,this.currentFilter)


}

open(content:any){
  this.modalService.open(content, { centered: true });
}


userdata:any

  assigned_to(){
    this.superuser = localStorage.getItem('is_superuser')

    if(this.superuser == 'true'){
            this.portal_name = localStorage.getItem('portal_name2')
            this.portal_id = localStorage.getItem('portal_id2')
            this.portal_account_id = localStorage.getItem('portal_account_id2')
            this.d2c_name = localStorage.getItem('d2c_name2')
      
          }
          else{
            this.portal_name = localStorage.getItem('portal_name')
             this.portal_id = localStorage.getItem('portal_id')
            this.portal_account_id = localStorage.getItem('portal_account_id')
            this.d2c_name = localStorage.getItem('d2c_name')
          }
    let data = {
      'portal_account_id': this.portal_account_id
    }
    this.authService.assigned_to(data).subscribe((res) => {
      let mes=JSON.parse(res)
      res =mes 
      if (res.statusCode>=200 && res.statusCode<=205) {
        this.showOverlay = false;
        // console.log(res,'get data res')
        this.userdata = res.body

     
      //   console.log("mesg", res.message); 
      // console.log(this.length,'lengthhhhhhhh')
  
      } 
      else {
        if(res.error =='Token has expired' || res.error =='Invalid token' || res.error =='Token is required'){
          // this.authService.logout()
          this.showOverlay=false
          this.router.navigate(['/auth/login'])
        }
        else{
          this.toastr.error(res.error, "");
          this.showOverlay = false; 
          // console.log('error mesg',res)
        }
      }
    }, (error) => {
      this.showOverlay = false;
      if (error.status === 502) {
        this.toastr.error("502 Bad Gateway", "An error occurred");
      } else {
        this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
      }
    }); 

}
    selectedRowIndexDepency: number=-1;

ticket_id1:any
editDependency(row: any) {
  const rowId = row.ticket_id
  this.ticket_id1 = row.ticket_id
  const rowIndex = this.apiData.findIndex(item => item.ticket_id == rowId);
  this.selectedRowIndexDepency = rowIndex;
}

saveDependency(value) {  
this.ticket_update1(value,this.ticket_id1)

}

dependencyDropDown = [
      {status:'missing order',name:'Missing Order'},
    {status:'"wrong product dispatched',name:'Wrong Product Dispatched'},
    {status:'order not received',name:'Order Not Received'},
    {status:'missing quantity"',name:'Missing Quantity'},
    {status:'wrong invoice shared',name:'Wrong Invoice Shared'},
    {status:'order delay',name:'Order Delay'},
    {status:'other',name:'Other'},
    {status:'Product/Checkout Issues',name:'Product/Checkout Issues	'},
]


  ticket_update1(data1:any,data2:any){
    this.showOverlay=true
    let data ={
      'ticket_id':data2,
      'category':data1
    }
    this.authService.ticket_update(data).subscribe((res: any) => {
      // console.log(res,'ticket data');
      let mes = JSON.parse(res);
      res = mes
      // console.log(mes);
      if (mes.statusCode === 200) {
        this.showOverlay=false
        this.toastr.success(mes.success, "");
        this.fetchData(this.paginate,this.currentFilter)


  }
  else{
    if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
      // this.authService.logout()
      this.showOverlay=false
      this.router.navigate(['/auth/login'])
    }
    else{
      this.toastr.error(mes.error, "");
      this.showOverlay = false; 
      this.toastr.error(mes.error, "");


  
    }
  
  
  }
  },
  (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
  });

  }



}
